/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { Link, TextField } from '@material-ui/core';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableComponent from './TableComponent';
import {
  DrugsNameHeader,
  DrugFamilyHeader,
  DrugSelectRow,
  DrugFamilySelectRow,
  hideColumns,
} from './TableHeader';
import { onCellFocused } from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ModalDialog from '../../../../SharedModules/Dialog/ModalDialog';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import ViewDrugDetails from './ViewDrugDetails';
import { setCurrentNDCDetailsSelected } from '../../../Display/NDC/store/action';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  closeTab,
  handleScrollToEvent,
  redirectURLLink,
  validDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

import {
  getDrugList,
  getDrugFamily,
  getNDCDetails,
  removeDrugFromList,
  viewDrugSection,
  saveDrugSeq,
  saveDrugFamily,
  LinkDrugFields,
  dispatchDrugFamily,
  getLabelerList,
  dispatchRowHighlight,
  buttonEnable,
  saveDrugFamilyVO,
  selectNdcParam,
  viewDrugDetailModal,
  getDrugFamilyDetail,
  dispatchDrugList,
} from '../store/action';
import {
  viewDrugDetails,
  createFlag,
} from '../../../Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import {
  ASSIGN_STARTDATE_ERROR,
  SUCCESSMESSAGE_GENERIC,
  STARTDATE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import { getDrugFamilyDetails } from '../../../Maintain/DrugFamily/DrugFamilySearch/store/actions';

import * as actionType from '../../../Maintain/DrugFamily/DrugFamilySearch/store/actionTypes';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';

const LinkNewDrugs = () => {
  const dispatch = useDispatch();
  const [drugfamilyDialog, setDrugfamilyDialog] = React.useState(false);
  const [drugfamilyCompareDialog, setDrugfamilyCompareDialog] =
    React.useState(false);
  const [allDrugList, setAllDrugList] = React.useState([]);
  const [drugFamilyList, setDrugFamilyList] = React.useState([]);
  const [gridApiLab, setGridApiLab] = React.useState(null);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const [savedRow, setSavedRow] = React.useState(null);
  const [removeList, setRemoveList] = React.useState(false);
  const [saveList, setSaveList] = React.useState(false);
  const [fullScreenView1, setFullScreenView1] = React.useState(false);
  const [fullScreenView2, setFullScreenView2] = React.useState(false);
  const [refresh, setRefresh] = React.useState(true);

  const [removeId, setRemveId] = React.useState(null);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [openSave, setOpenSave] = React.useState(false);
  const [rowBackground, setRowBackground] = React.useState();
  const [closeConfirm, setCloseConfirm] = React.useState(false);
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const [successMessages, setSuccessMessages] = React.useState([]);
  const toggle = useRef(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [testName, setTestName] = React.useState('');
  const [flag, setFlag] = React.useState(false);
  const [lockedDrugSequence, setLockedDrugSequence] = React.useState(null);
  const logInUserID = useSelector((state) => state.sharedState.logInUserID);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const history = useHistory();
  const {
    drugList,
    drugFamily,
    linkDrugFields,
    buttonEnableList,
    savedDrugVo,
    selectedNdc,
  } = useSelector((state) => state.sharedState.LinkNewDrugsReducer);
  const drugSequence = useSelector(
    (state) => state.sharedState.LinkNewDrugsReducer.drugSeqNumber
  );
  const rowHighlight = useSelector(
    (state) => state.sharedState.LinkNewDrugsReducer.rowHighlight
  );

  const drug_family_details = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.drug_family_details
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [assignSatrtDate, setAssignStartDate] = React.useState({
    value: moment(new Date()).format('MM/DD/YYYY'),
    error: false,
    errMsg: [],
  });

  const [selectSeq, setSelectSeq] = React.useState('');
  const dateReg = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
  const monthReg = /^(\d{1,2})\/(\d{4})$/;

  const handleOnChangeEvent = (data, key) => {
    assignSatrtDate.error = false;
    assignSatrtDate.errMsg = [];
    setAssignStartDate((prev) => ({
      ...prev,
      value: data,
    }));
  };
  const handleOnBlueEvent = (e) => {
    const dateValue = autoFormateDate(e.target.value);
    const obj = linkDrugFields?.assignSatrtDate
      ? linkDrugFields?.assignSatrtDate
      : {
          value: moment(new Date()).format('MM/DD/YYYY'),
          errMsg: [],
          error: false,
        };
    if (e.target.value === '') {
      obj.errMsg = [STARTDATE_REQUIRED];
      obj.error = true;
    } else if (!dateValue?.includes('/')) {
      obj.errMsg = [ASSIGN_STARTDATE_ERROR];
      obj.error = true;
    } else {
      obj.error = false;
      obj.errMsg = [];
    }
    setAssignStartDate({
      ...obj,
      value: dateValue,
    });
    setFlag(true);
    dispatch(
      LinkDrugFields({
        assignSatrtDate: {
          ...obj,
          value: dateValue,
        },
      })
    );
  };
  // Revert Start Date when user cancel Selection
  const revertDate = () => {
    setAssignStartDate((prev) => ({
      ...prev,
      value: moment(new Date()).format('MM/DD/YYYY'),
      errMsg: [],
      error: false,
    }));
    dispatch(
      LinkDrugFields({
        assignSatrtDate: {
          value: moment(new Date()).format('MM/DD/YYYY'),
          errMsg: [],
          error: false,
        },
      })
    );
    const array = drugFamilyList?.map((data) => {
      const obj = data;
      obj.familySeqNum = data.family;
      obj.familyName = data.familyName;
      obj.brandName = data.brandName;
      obj.specificTheraClass = data.stc;
      obj.drugSeqNo = data.drugSeqNo;
      obj.startDate = data.startDate;
      if (data.family === selectSeq) {
        obj.startDate = moment(new Date()).format('MM/DD/YYYY');
      }
      return obj;
    });
    dispatch(dispatchDrugFamily(array));
  };
  const checkYear = (value) => {
    const val = value.split('/');
    if (value != '' && val.length > 2) {
      return val[2];
    }
  };

  // Start Date Validations
  const getValue = () => {
    const { value } = assignSatrtDate;

    if (checkYear(value)?.length === 2 && value.length !== 7) {
      const val = value.split('/');
      assignSatrtDate.value = `${val[0]}/${val[1]}/20${val[2]}`;
      setAssignStartDate((prev) => ({
        ...prev,
      }));
      return false;
    }
    if (value === '') {
      return true;
    }
    if (value.length > 7 && !dateReg.test(value)) {
      return true;
    }
    if (value.length <= 7 && !monthReg.test(value)) {
      return true;
    }
    return false;
  };

  // Start Date submission
  const submitAssignDate = (param, e) => {
    const obj = {};
    if (getValue()) {
      if (assignSatrtDate?.value == '') {
        assignSatrtDate.errMsg = [STARTDATE_REQUIRED];
        obj.errMsg = [STARTDATE_REQUIRED];
      } else {
        assignSatrtDate.errMsg = [ASSIGN_STARTDATE_ERROR];
        obj.errMsg = [ASSIGN_STARTDATE_ERROR];
      }
      assignSatrtDate.error = true;
      obj.error = true;
    } else {
      assignSatrtDate.error = false;
      assignSatrtDate.errMsg = [];
      obj.error = false;
      obj.errMsg = [];
      const updatedArray = drugFamilyList?.map((data) => {
        const obj = data;
        if (data?.family == selectSeq) {
          obj.startDate = autoFormateDate(assignSatrtDate.value);
        }
        return obj;
      });

      // dispatch(dispatchDrugFamily())
      setFlag(true);
      dispatch(LinkDrugFields({ assignSatrtDate: obj }));
      if (param !== 'onblur') {
        setDrugfamilyDialog(false);
      }
    }
    obj.value = assignSatrtDate.value;
    setAssignStartDate((prev) => ({
      ...prev,
    }));
    setAllDrugList(allDrugList);
  };

  // Drug List API Call
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(dispatchDrugList([]));
    dispatch(dispatchDrugFamily([]));
    dispatch(getDrugList({}));
    if (linkDrugFields) {
      dispatch(
        LinkDrugFields({
          assignSatrtDate: linkDrugFields?.assignSatrtDate
            ? linkDrugFields?.assignSatrtDate
            : {
                value: moment(new Date()).format('MM/DD/YYYY'),
                errMsg: [],
                error: false,
              },
        })
      );
    } else {
      dispatch(LinkDrugFields({ assignSatrtDate: assignSatrtDate }));
    }
  }, []);

  React.useEffect(() => {
    if (buttonEnableList) {
      setSaveList(buttonEnableList?.saveList);
      setRemoveList(buttonEnableList?.removeList);
    }
    if (savedDrugVo) {
      setSavedRow(savedDrugVo);
    }
  }, [buttonEnableList, savedDrugVo]);

  React.useEffect(() => {
    let arrayList = [];
    let drugFamilyArray = [];
    if (drugList?.length > 0) {
      arrayList = drugList?.map((data) => {
        return {
          ndc: data.ndc,
          drugName: data.drugName,
          drugSeqNo: data.drugSeqNum,
        };
      });
    }
    setAllDrugList(arrayList?.length > 0 ? arrayList : allDrugList);
    if (drugFamily?.length > 0) {
      drugFamilyArray =
        drugFamily &&
        drugFamily?.length > 0 &&
        drugFamily?.map((data) => {
          return {
            family: data.familySeqNum,
            familyName: data.familyName,
            brandName: data.brandName,
            stc: data.specificTheraClass,
            drugSeqNo: drugSequence,
            startDate:
              data?.startDate || moment(new Date()).format('MM/DD/YYYY'),
          };
        });
    }
    setDrugFamilyList(
      drugFamilyArray?.length > 0 ? drugFamilyArray : drugFamily
    );
  }, [drugList, drugFamily]);

  // Get Drug Family Data on Selection
  const onSelectAction = (key, param) => {
    dispatch(dispatchDrugFamily([]));
    storeNdc(param);
    dispatch(
      getDrugFamily({
        drugSeqNum: param.data.drugSeqNo,
      })
    );
  };

  // Get NDC Details
  const getNdcData = async (cellInfo) => {
    const { drugName, ndc } = cellInfo?.data;
    const response = await getNDCDetails([
      {
        ndc: ndc,
        drugName: drugName,
      },
    ]);

    if (response.message === 'SUCESS') {
      dispatch(setCurrentNDCDetailsSelected(response?.data[0],'All'));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };

  // Go to Drug Family Details Page
  const goToDrugFamily = async (cellInfo, key) => {
    const { family } = cellInfo?.data;
    const response = await getDrugFamilyDetail({
      familySeqNum: family,
    });
    if (response.message === 'SUCESS') {
      dispatch(saveDrugFamilyVO(response?.drugFamilyWrapperVO));
      dispatch(viewDrugDetails(response?.drugFamilyWrapperVO?.drugFamilyVO));
      dispatch(viewDrugDetailModal(response?.drugFamilyWrapperVO));
      if (key !== 'modal') {
        redirectURLLink(
          '/drugFamilyDetail',
          'Maintain Drug Family',
          history,
          dispatch
        );
      }
    }
  };

  const goToDrugFamilyRedirection = (cellInfo, key) => {
    const { family } = cellInfo?.data;
    dispatch(
      getDrugFamilyDetails({
        familySeqNum: family,
      })
    );
  };

  React.useEffect(() => {
    if (drug_family_details) {
      const { status, message } = drug_family_details;
      if (message === 'SUCESS' && status === '001') {
        dispatch({
          type: actionType.DRUG_FAMILY_DAETAILS,
          payload: null,
        });
        if (drug_family_details?.drugFamilyVOs?.length > 1) {
          dispatch({
            type: actionType.POPUP_TABLE_DATA,
            payload: drug_family_details.drugFamilyVOs,
          });
        } else {
          dispatch(createFlag(false));

          localStorage.setItem('updatedetails', true);
          redirectURLLink(
            '/drugFamilyDetail',
            'Maintain Drug Family',
            history,
            dispatch
          );
        }
      }
    }
  }, [drug_family_details]);

  // Refresh Functionality
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const test = !(removeList || saveList);
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs?.map((item) => {
        if (item.navTo === '/linknewdrugstodrugfamily' && !test) {
          item.isFormDirty = true;

          if (assignSatrtDate.error) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else {
          item.isFormDirty = false;
        }
        return item;
      });

    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [assignSatrtDate, removeList, saveList]);

  // Assign Date Error messages
  React.useEffect(() => {
    if (linkDrugFields?.assignSatrtDate) {
      const { error, errMsg, value } = linkDrugFields?.assignSatrtDate;
      setAssignStartDate((prev) => ({
        ...prev,
        error: error || false,
        errMsg: errMsg || [],
        value: value || moment(new Date()).format('MM/DD/YYYY'),
      }));
    }
  }, [linkDrugFields]);

  const storeNdc = (cellInfo) => {
    const { drugSeqNo, ndc, drugName } = cellInfo?.data;
    dispatch(saveDrugSeq(drugSeqNo));
    dispatch(
      selectNdcParam({
        ndc: ndc,
        drugName: drugName,
      })
    );
  };

  // Remove Drug from Drug List API Call
  const removeDrugFamilyInfo = async (value) => {
    setSuccessMessages([]);
    const response = await removeDrugFromList({
      drugSeqNum: lockedDrugSequence,
      updateUserId: logInUserID != undefined ? logInUserID : logInUser,
    });
    if (response.message === 'SUCESS') {
      if (!value) {
        closeTab('/linknewdrugstodrugfamily', history, dispatch);
      }
      setRemoveList(false);
      dispatch(getDrugList({}));
      dispatch(saveDrugSeq(null));
      setSuccessMessages([SUCCESSMESSAGE_GENERIC]);
      // setTimeout(() => 
      //   setSuccessMessages([]),
      //  5000);
      dispatch(buttonEnable({ removeList: false, saveList: false }));
      setOpenSave(false);
      setLockedDrugSequence(null);
    }
  };

  // Save Drug Family Logic
  const saveDrugDetails = async (value) => {
    setSuccessMessages([]);
    setClickOncloseTabBtn(value);
    const keyList1 = [
      'familySeqNum',
      'familyName',
      'familyDescr',
      'mfgId',
      'brandName',
      'specificTheraClass',
      'wacPct',
      'endDate',
      'lastUpdateDate',
      'lastUpdateUserId',
    ];
    const keyList2 = [
      'familySeqNum',
      'endDate',
      'lastUpdateDate',
      'lastUpdateUserId',
    ];

    if (removeList) {
      removeDrugFamilyInfo(value);
    }
    if (saveList) {
      const { drugFamilyVO } = savedRow;
      const obj1 = {};
      const obj2 = {};
      if (drugFamilyVO) {
        keyList1 &&
          keyList1.length > 0 &&
          keyList1.map((data) => {
            if (Object.keys(drugFamilyVO).includes(data)) {
              obj1[data] = drugFamilyVO[data];
            }
            obj1.lastUpdateUserId =
              logInUserID != undefined ? logInUserID : logInUser;
          });

        keyList2 &&
          keyList2.length > 0 &&
          keyList2.map((data) => {
            if (Object.keys(drugFamilyVO).includes(data)) {
              obj2[data] = drugFamilyVO[data];
            }
            obj2.startDt = moment(assignSatrtDate.value).format('MM/DD/YYYY');
            obj2.drugSeqNum = drugSequence;
            obj2.lastUpdateUserId =
              logInUserID != undefined ? logInUserID : logInUser;
          });
      }
      const response = await saveDrugFamily({
        drugFamily: obj1,
        savedrugFamilyDrugs: [obj2],
      });

      if (response.message === 'SUCESS') {
        setSuccessMessages([SUCCESSMESSAGE_GENERIC]);
        // setTimeout(() => setSuccessMessages([]), 5000);
        dispatch(dispatchRowHighlight({ red: false, yellow: false }));
        dispatch(dispatchDrugList([]));
        dispatch(dispatchDrugFamily([]));
        dispatch(dispatchDrugList([]));
        dispatch(dispatchDrugFamily([]));
        dispatch(getDrugList({}));
        onGridReady(gridParams);
        if (!value) {
          closeTab('/linknewdrugstodrugfamily', history);
        }
        dispatch(buttonEnable({ removeList: removeList, saveList: false }));

        setOpenSave(false);
      }
    }
  };
  // Close Tab functionality
  React.useEffect(() => {
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/linknewdrugstodrugfamily' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs?.map((item) => {
        if (item.navTo === '/linknewdrugstodrugfamily' && item.isFormSave) {
          item.isFormSave = false;
          saveDrugDetails(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [updateTabs]);
  // Compare Drug Details Modal popup open

  const linkDrugFamily = (cellInfo) => {
    setSuccessMessages([]);
    setRefresh(false);
    setTestName(cellInfo?.data?.familyName);

    setAssignStartDate((prev) => ({
      ...prev,
      value: cellInfo?.data?.startDate,
      errMsg: [],
      error: false,
    }));
    setSelectSeq(cellInfo?.data?.family);
    setDrugfamilyDialog(true);
    setFlag(false);
    goToDrugFamily(cellInfo, 'modal');
  };

  const handelCancelClose = () => {
    setOpenCancel(false);
  };

  const handelSaveClose = () => {
    setOpenSave(false);
  };

  // Fullscreen View
  const changeFullScreenView = (key) => {
    setSuccessMessages([]);
    let view;
    if (key === 1) {
      view = !fullScreenView1;
      setFullScreenView1(!fullScreenView1);
    } else {
      view = !fullScreenView2;
      setFullScreenView2(!fullScreenView2);
    }
  };

  const removeAssociation = (cellInfo) => {
    setSuccessMessages([]);
    storeNdc(cellInfo);
    // setRemveId(cellInfo.data.drugSeqNo);
    setAllDrugList(allDrugList);
    dispatch(dispatchRowHighlight({ red: true, yellow: false }));
    dispatch(buttonEnable({ removeList: true, saveList: saveList }));
  };

  React.useEffect(() => {
    if (rowHighlight && rowHighlight.yellow) {
      setAllDrugList(allDrugList);
      setRowBackground({
        'frr-yellow-bg': function (params) {
          const selectedDrug = params.data.drugSeqNo;
          return Number(selectedDrug) == drugSequence;
        },
      });
    } else if (rowHighlight && rowHighlight.red) {
      setAllDrugList(allDrugList);
      setLockedDrugSequence(drugSequence);
      setRowBackground({
        'frr-red-bg': function (params) {
          const selectedDrug = params.data.drugSeqNo;
          return Number(selectedDrug) === drugSequence;
        },
      });
    } else {
      setRowBackground({});
    }

    if (gridApi) {
      gridApi.redrawRows();
      gridApi.deselectAll();
    }
  }, [rowHighlight]);

  // Confirm Popup functionality
  const onConfirmPopup = () => {
    handelCancelClose();
    dispatch(dispatchDrugList([]));
    dispatch(dispatchDrugFamily([]));
    dispatch(getDrugList({}));
    setOpenCancel(false);
    setRemveId(null);
    revertDate();
    dispatch(buttonEnable({ removeList: false, saveList: false }));
    dispatch(dispatchRowHighlight({ red: false, yellow: false }));
    onGridReady(gridParams);
  };

  const openCancelPopUp = (value) => {
    setOpenCancel(value);
  };
  React.useEffect(() => {
    if (selectedRow && refresh) {
      dispatch(
        selectNdcParam({
          ndc: selectedRow[0]?.ndc,
          drugName: selectedRow[0]?.drugName,
        })
      );
    }
  }, [selectedRow, refresh]);
  const handleFetchDrugFamilyData = (drugSeqNo) => {
    dispatch(saveDrugSeq(drugSeqNo));
    dispatch(
      getDrugFamily({
        drugSeqNum: drugSeqNo,
      })
    );
    setRemveId(drugSeqNo);
  };
 
 const onGridReady = (params, type) => {
  setGridApi(params.api);
  setGridParams(params);
  params.api.ensureIndexVisible(0);

  const handleSelection = () => {
    let selectedRow;

    if (drugSequence) {
      params.api.forEachNode((node) => {
        if (node?.data?.drugSeqNo == drugSequence) {
          node.setSelected(true);
          selectedRow = node.data;
        }
      });
    }

    if (!selectedRow) {
      params.api.forEachNode((node) => {
        if (node && node.rowIndex == 0) {
          node.setSelected(true);
          selectedRow = node.data;
        }
      });
    }
    dispatch(dispatchDrugFamily([]));

    if (selectedRow?.drugSeqNo) {
      handleFetchDrugFamilyData(selectedRow.drugSeqNo, type);
    }
  };

  params.api.addEventListener('firstDataRendered', handleSelection);
  if (params.api.getDisplayedRowCount() > 0) {
    handleSelection();
  }
};



  React.useEffect(() => {
    dispatch(buttonEnable({ removeList: false, saveList: false }));
  }, []);
  return (
    <div className="tabs-container" data-testid="linkNewDrugs">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Tasks"
        parent2="Link New Drugs to Drug Families"
      />
      <DisplaySuccessMessages successMessages={successMessages} />
      <div className="btn-wrapper mb-2">
        <SaveCancelPopup
          data-testid="cancelPopup1"
          open={openCancel}
          title="Cancel"
          onConfim={() => {
            onConfirmPopup();
          }}
          onCancel={() => {
            handelCancelClose();
          }}
        />

        <SaveCancelPopup
          data-testid="savePopup"
          open={openSave}
          title="Save"
          onConfim={() => saveDrugDetails(true)}
          onCancel={() => {
            handelSaveClose();
          }}
        />
        {!fullScreenView1 && !fullScreenView2 && (
          <div className="float-right mt-2 hide-on-print">
            <Button
              className="btn btn-success btn-search"
              data-testid="openSave"
              onClick={() => setOpenSave(true)}
              disabled={!(removeList || saveList)}
            >
              <SVGComponent iconName="Icon-awesome-save" /> Save
            </Button>
            <Button
              className="btn btn-cancel"
              data-testid="cancelBtn"
              onClick={() => {
                openCancelPopUp(true);
              }}
              disabled={!(removeList || saveList)}
            >
              <SVGComponent iconName="Icon-cancel" /> Cancel
            </Button>
          </div>
        )}
        <div className="clearfix" />
      </div>
      <div className="row row_wrap">
        {!fullScreenView2 && allDrugList && (
          <div
            className={`col-${
              !fullScreenView1 ? '6' : '12'
            } panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-drug_section frr-link_drug`}
          >
            <TableComponent
              onGridReady={(e) => onGridReady(e, 'drug')}
              setSelectedRow={setSelectedRow}
              className="frr-drug-selection-label"
              searchByDrugNameTableData={allDrugList || []}
              gridApi={gridApiLab}
              getGridData={(data) => setGridApiLab(data)}
              gridHeight={fullScreenView1 ? '70vh' : 313}
              columnName={DrugsNameHeader}
              rowSelection="multiple"
              fileName="Drug Selection"
              fullScreenView={fullScreenView1}
              onSelect={(e) => onSelectAction('drugSelection', e)}
              handleFullScreenView={false}
              handleFullScreenViewClick={() => changeFullScreenView(1)}
              exportFile
              singleClickEdit
              suppressCellFocus
              onCellFocused={onCellFocused}
              handleAddNewRow={false}
              helpMessage="Drug Selection"
              hideColumnsInPdf={hideColumns}
              rowClassRules={rowBackground}
              drugselection
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  return (
                    <div
                      className="tdCell icon-btn-group"
                      data-testid="action-column"
                    >
                      <Dropdown className="icon-dropdown-container">
                        <Dropdown.Toggle
                          className="icon-dropdown export_wrap"
                          aria-label="export"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="action-tooltip">Actions</Tooltip>
                            }
                          >
                            <SVGComponent iconName="Icon-export1" />
                          </OverlayTrigger>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="export_dropdown">
                          <Dropdown.Item
                            role="button"
                            onClick={() => removeAssociation(cellInfo)}
                          >
                            DF Association Not Needed
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  );
                },
                ndcLinkRender: (cellInfo) => {
                  return (
                    <Link
                      to="#"
                      role="button"
                      onClick={() => getNdcData(cellInfo)}
                    >
                      {cellInfo && cellInfo.data.ndc}
                    </Link>
                  );
                },
              }}
            />
          </div>
        )}
        {!fullScreenView1 && (
          <div
            className={`col-${
              !fullScreenView2 ? '6' : '12'
            } panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-drug_section`}
          >
            <TableComponent
              searchByDrugNameTableData={drugFamilyList || []}
              selectionRows
              gridHeight={fullScreenView2 ? '70vh' : 313}
              columnName={DrugFamilyHeader}
              rowSelection="single"
              fileName="Drug Family Selection"
              fullScreenView={fullScreenView2}
              handleFullScreenView={false}
              handleFullScreenViewClick={() => changeFullScreenView(2)}
              exportFile
              isScrollOn
              handleAddNewRow={false}
              helpMessage="Drug Family Selection"
              drugfamilyselection
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  return (
                    <div
                      className="tdCell icon-btn-group"
                      data-testid="action-column"
                    >
                      <Dropdown className="icon-dropdown-container">
                        <Dropdown.Toggle
                          className="icon-dropdown export_wrap"
                          aria-label="export"
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="action-tooltip">Actions</Tooltip>
                            }
                          >
                            <SVGComponent iconName="Icon-export1" />
                          </OverlayTrigger>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="export_dropdown">
                          <Dropdown.Item
                            role="button"
                            onClick={() => {
                              dispatch(
                                viewDrugSection({
                                  drugSeqNum: cellInfo.data.drugSeqNo,
                                })
                              );
                              // getNdcData(selectedNdc, 'view')
                              goToDrugFamily(cellInfo, 'modal');
                              setRefresh(false);
                              setDrugfamilyCompareDialog(true);
                              setSuccessMessages([]);
                              setTestName(cellInfo?.data?.familyName);
                            }}
                          >
                            Compare Drug to Drug Family
                          </Dropdown.Item>
                          <Dropdown.Item
                            role="button"
                            onClick={() => linkDrugFamily(cellInfo)}
                          >
                            Link Drug to Drug Family
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  );
                },
                ndcLinkRender: (cellInfo) => {
                  return (
                    <Link
                      to="#"
                      role="button"
                      onClick={() => goToDrugFamilyRedirection(cellInfo)}
                    >
                      {cellInfo && cellInfo.data.family}
                    </Link>
                  );
                },
              }}
            />
          </div>
        )}
        <CommonModal
          open={drugfamilyCompareDialog}
          viewAction
          viewHeader
          onOk={() => {
            setDrugfamilyCompareDialog(false);
            setDrugfamilyDialog(true);
          }}
          okTitle="Link Drug to Drug Family"
          onClose={() => setDrugfamilyCompareDialog(false)}
          closeTitle="Cancel"
          modalTitle="View Drug/Drug Family Details"
          childrenComponent={
            <ViewDrugDetails
              assignDate={assignSatrtDate?.value}
              selectedNdcs={selectedNdc}
            />
          }
        />
        <CommonModal
          open={drugfamilyDialog}
          viewAction
          viewHeader
          className="dialog-420 rr-dialog-css"
          onOk={() => {
            submitAssignDate();
            dispatch(dispatchRowHighlight({ red: false, yellow: true }));
            dispatch(buttonEnable({ removeList: removeList, saveList: true }));
          }}
          okTitle="Ok"
          onClose={(val) => {
            if (val === 'button') {
              if (flag) {
                revertDate();
              }
              setDrugfamilyDialog(false);
            } else {
              setDrugfamilyDialog(false);
            }
          }}
          closeTitle="Cancel"
          modalTitle="Assign Start Date"
          childrenComponent={
            <div className="mui-custom-form input-md frr-drugStart">
              <DisplayErrorMessages
                errorMessages={assignSatrtDate.errMsg || []}
              />

              <TextField
                id="corpName"
                label={`Please Enter a Start Date for ${testName}`}
                required
                fullWidth
                data-testid="assgignStart"
                placeholder=""
                inputProps={{ maxLength: 45 }}
                value={assignSatrtDate.value || ''}
                error={assignSatrtDate.error || ''}
                helperText={assignSatrtDate?.errMsg[0] || ''}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  handleOnChangeEvent(e.target.value, 'assignStart');
                }}
                onBlur={(e) => {
                  handleOnBlueEvent(e);
                }}
              />
              {/* </div> */}
            </div>
          }
        />

        <SaveCancelPopup
          data-testid="cancelPopup2"
          open={closeConfirm}
          title="Cancel"
          onConfim={() => {
            onConfirmPopup();
          }}
          onCancel={() => {
            handelCancelClose();
          }}
        />
      </div>
    </div>
  );
};

export default LinkNewDrugs;
